 import { connect } from 'react-redux';
import SearchInput from '../components/SearchInput'
import { handleSearchChange } from "../redux/modules/users";


function mapStateToProps({users: {searchValue} }) {
    return {
        searchValue // gives our component access to state through props.mobileOpen
    }
}
function mapDispatchToProps(dispatch) {
    return {
        handleSearchChange: value => dispatch(handleSearchChange(value)),
    }; // here we're mapping actions to props
}
export default connect(mapStateToProps, mapDispatchToProps)(SearchInput);



// WEBPACK FOOTER //
// ./src/containers/searchInput.js